/**
 * CheckMark
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon2 from './index.js';

function CheckMark(props) {
  const { value, className, falseClass = 'ss-minus opacity-25', ...rest } = props;
  const colorClass = value ? 'text-success' : 'text-danger';
  const classList = classNames([value ? 'ss-checkmark' : falseClass, 'fs-2', colorClass, className]);
  return <Icon2 className={classList} {...rest} />;
}

CheckMark.propTypes = {
  value: PropTypes.bool,
  className: PropTypes.string,
  falseClass: PropTypes.string,
};

export default CheckMark;
